// extracted by mini-css-extract-plugin
export default {"tabItem":"styles_tabItem__CWpkr"};